import React, { useEffect, useState } from 'react'
import { BrowserRouter as RouterModule, Switch, Route, Redirect, useLocation } from 'react-router-dom'
import { CSSTransition, TransitionGroup } from 'react-transition-group'
import { useStore } from './'
import {
  BlankWindow,
  Certificate,
  Credits,
  Dashboard,
  Game1,
  Game2,
  Game3,
  Game4,
  Game5,
  Game6,
  Game7,
  Game8,
  Game9,
  Game10,
  Login,
  NotFound404,
  PublicHome,
} from '../views'
import { Loader } from '../components'

type Props = {}
export const Router: React.FC<Props> = () => {
  const [isReady, setIsReady] = useState(false)
  const { state, patchState } = useStore()

  useEffect(() => {
    setIsReady(true)
  }, [])
  if (!isReady) {
    return <Loader />
  }
  return (
    <RouterModule basename={process.env.PUBLIC_URL}>
      <Routes />
    </RouterModule>
  )
}

const Routes = () => {
  const location: any = useLocation()
  return (
    <main id={'router'}>
      {/*<RootRedirect />*/}
      <TransitionGroup>
        <CSSTransition timeout={500} classNames="reroute" key={location?.key}>
          <Switch location={location}>
            <Route exact path="/">
              <PublicHome />
            </Route>
            <Route path="/login">
              <Login />
            </Route>
            <Route path="/o-aplikaci">
              <Credits />
            </Route>
            <AuthenticatedRoute path="/dashboard">
              <Dashboard />
            </AuthenticatedRoute>
            <AuthenticatedRoute path="/diplom">
              <BlankWindow children={<Certificate />} />
              {/*<Certificate />*/}
            </AuthenticatedRoute>
            <AuthenticatedRoute path="/hra/hlasy-lesa">
              <Game1 />
            </AuthenticatedRoute>
            <AuthenticatedRoute path="/hra/myslivecka-mluva">
              <Game2 />
            </AuthenticatedRoute>
            <AuthenticatedRoute path="/hra/lesni-stopar">
              <Game3 />
            </AuthenticatedRoute>
            <AuthenticatedRoute path="/hra/drevo-kolem-nas">
              <Game4 />
            </AuthenticatedRoute>

            <AuthenticatedRoute path="/hra/lesni-plody">
              <Game5 />
            </AuthenticatedRoute>

            <AuthenticatedRoute path="/hra/obyvatele-lesa">
              <Game6 />
            </AuthenticatedRoute>
            <AuthenticatedRoute path="/hra/k-cemu-slouzi">
              <Game9 />
            </AuthenticatedRoute>

            <AuthenticatedRoute path="/hra/co-do-lesa-nepatri">
              <Game7 />
            </AuthenticatedRoute>
            <AuthenticatedRoute path="/hra/profese">
              <Game8 />
            </AuthenticatedRoute>
            <AuthenticatedRoute path="/hra/od-seminka-po-vyrobek">
              <Game10 />
            </AuthenticatedRoute>
            {/*<AuthenticatedRoute path="/game/:id">*/}
            {/*  <Game2 />*/}
            {/*</AuthenticatedRoute>*/}
            <Route path="*">
              <NotFound404 />
            </Route>
          </Switch>
        </CSSTransition>
      </TransitionGroup>
    </main>
  )
}

const AuthenticatedRoute: React.FC<any> = ({ children, ...props }) => {
  const { state } = useStore()
  return (
    <Route
      {...props}
      render={({ location }) =>
        state?.username?.length > 0 ? (
          children
        ) : (
          <Redirect
            to={{
              pathname: '/login',
              state: { from: location },
            }}
          />
        )
      }
    />
  )
}

const RootRedirect = () => {
  const location: any = useLocation()
  if (location.pathname === '/') {
    return (
      <Redirect
        to={{
          pathname: '/login',
          state: { from: location },
        }}
      />
    )
  }
  return null
}
